import { useGetLogFilterOptionsQuery } from "generated/graphql";

export const FILTER_FIELDS = ["name", "email", "section", "region"] as const;
export type FilterField = (typeof FILTER_FIELDS)[number];

type FilterResults = Record<
  FilterField,
  ReturnType<typeof useGetLogFilterOptionsQuery>
>;

export const useAuditLogFilterOptions = (): FilterResults => {
  const name = useGetLogFilterOptionsQuery({ variables: { field: "user" } });
  const email = useGetLogFilterOptionsQuery({ variables: { field: "email" } });
  const section = useGetLogFilterOptionsQuery({
    variables: { field: "section" },
  });
  const region = useGetLogFilterOptionsQuery({
    variables: { field: "region" },
  });

  return { name, email, section, region };
};
